import React from "react";
import { Header } from "../components/shared";
import {
  AddOnSelector,
  BookingSummary,
  CheckoutFooter,
} from "../components/checkout";
import "../styles/checkout/Checkout.css";
import "../styles/shared/BookingComponents.css";

const CheckoutStep3 = () => {
  return (
    <div className="checkout-step3-container">
      <Header />
      <main className="checkout-main-content">
        <AddOnSelector />
        <BookingSummary />
      </main>
      <CheckoutFooter />
    </div>
  );
};

export default CheckoutStep3;
